<template>
  <BadgeSize
    v-if="box"
    color="primary-lighten-3"
    :content="getBoxInboxCountText(box)"
    :offset-y="-2"
    :size="18"
    :size-font="isInboxCountBiggerThen2Chars(box) ? 10 : 12"
    text-color="primary"
  >
    <slot></slot>
  </BadgeSize>
</template>

<script setup lang="ts">
import { useBoxAvatar } from '@/composables/box/box-avatar'
import BadgeSize from '@/components/dashboard/BadgeSize.vue'
import type { BoxEntry } from '@deepcloud/api-deep-box'

defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
})

const { isInboxCountBiggerThen2Chars, getBoxInboxCountText } = useBoxAvatar()
</script>
